import CONST_REQUEST from '../../constants/request';
import * as api from '../../api/order';
import apiTools from '../../utils/store'

const types = {
    ...apiTools.getTypes([
        'orderDetail',
        'orderDetailForCollection',
        'repayPlanList',
        'examineLogList',
        'collectionLogList',
        'orderNumberList',
        'addressBookList',
        'repayRecordList',
        'repayRecordListV2',
         'orderImageList',
      'repayFlowList'
    ]),
}

const getDefaultState = () => {
    return {
        ...apiTools.getStates([
            'orderDetail',
            'orderDetailForCollection',
            'repayPlanList',
            'examineLogList',
            'collectionLogList',
          'orderNumberList',
            'addressBookList',
            'repayRecordList',
            'repayRecordListV2',
          'orderImageList',
          'repayFlowList'
        ]),
    }
}

const getters = {
        ...apiTools.getGetters([
            'orderDetail',
            'orderDetailForCollection',
            'repayPlanList',
            'examineLogList',
            'collectionLogList',
          'orderNumberList',
            'addressBookList',
            'repayRecordList',
            'repayRecordListV2',
          'orderImageList',
          'repayFlowList'
        ])
    }

const buildAction = (apiName) => {
    return ({ commit }, params) => {
        return api[apiName](params).then((res) => {
            if (res.code == CONST_REQUEST.CODE_SUCCESS) {
                return res
            } else {
                throw new Error(res.msg)
            }
        })
    }
}

const actions = {
        ...apiTools.getActions([
            'getOrderDetail',
            'getOrderDetailForCollection',
            'getRepayPlanList',
            'getExamineLogList',
            'getCollectionLogList',
            'getOrderNumberList',
            'getRepayRecordList',
            'getRepayRecordListV2',
            'getRepaymentReport',
            'downRepaymentReportExcel',
            'getAddressBookList',
            'getOrderImageList',
            'getOverdueReportRate',
            'downOverdueReportExcel',
          'getRepayFlowList'

        ], { types, api, CONST_REQUEST }),
    }

const mutations = {
    ...apiTools.getMutations([
        'orderDetail',
        'orderDetailForCollection',
        'repayPlanList',
        'examineLogList',
        'collectionLogList',
        'addressBookList',
        'orderNumberList',
        'repayRecordList',
        'repayRecordListV2',
      'orderImageList',
      'repayFlowList'

    ], { types, CONST_REQUEST })
}


export default {
    namespaced: true,
    state: getDefaultState(),
    getters,
    actions,
    mutations
}